import React, { ReactNode, useEffect } from "react";
import useAppSelector from "../../hooks/useAppSelector";
import { useNavigate } from "react-router-dom";

interface IAuthProviderProps {
  children: ReactNode;
}

const AuthProvider: React.FC<IAuthProviderProps> = ({ children }) => {
  const navigate = useNavigate();
  const { isAuthorized, user } = useAppSelector((state) => state.userProfileSlice);

  useEffect(() => {
    if (isAuthorized === false) {
      navigate("/login");
    }
    if (user) {
      if (user.isPreregistered) {
        navigate("/login");
      }
    }
  }, [isAuthorized, navigate]);

  return <>{isAuthorized && children}</>;
};

export default AuthProvider;
